
import VuexPersistence from 'vuex-persist';

/**
 * document: https://www.npmjs.com/package/vuex-persist
 * @param {modules}	string[]	List of modules you want to persist. (Do not write your own reducer if you want to use this)
 * @param {modules}	string[]	List of modules you want to persist. (Do not write your own reducer if you want to use this)
 * @param {modules}	string[]	List of modules you want to persist. (Do not write your own reducer if you want to use this)
 * @param {modules}	string[]	List of modules you want to persist. (Do not write your own reducer if you want to use this)
 * @param {modules}	string[]	List of modules you want to persist. (Do not write your own reducer if you want to use this)
 * 
 * 
 */

// 
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['runActivityManage', 'partner']
})
 

export default vuexLocal;
